import Vue from 'vue'
import numeral from 'numeral'

Vue.filter('currency', value => {
  /* eslint-disable */
  if (value === null || value === '' || isNaN(value)) return ''
  return /\￥/.test(value) ? value : `￥${Number(value).toFixed(1)}`
})

Vue.filter('currency2', value => {
  /* eslint-disable */
  if (value === null || value === '' || isNaN(value)) return ''
  return /\￥/.test(value) ? value : `￥${Number(value).toFixed(2)}`
})

Vue.filter('currency0', value => {
  /* eslint-disable */
  if (value === null || value === '' || isNaN(value)) return ''
  return /\￥/.test(value) ? value : `￥${Number(value).toFixed(0)}`
})
const baseFormat = (input, format = '0,0.00') => {
  // input [undefined,null,string,number]
  if (input === undefined || input === null) return input
  // convert number to string
  input = String(input).replace(/,/g, '')
  // convert stand string to number
  const value = Number.parseFloat(input)
  if (Number.isNaN(value)) {
    return input
  }
  let result = numeral(value).format(format)
  return result === 'NaN' ? input : result
}

Vue.filter('currencyNormal', baseFormat)



// WEBPACK FOOTER //
// ./src/filter/currency.js